import { useDraggable } from '@dnd-kit/core';
import { Button } from '@mui/material';
import { useState } from 'react';

const KanbanCard = ({
    item,
    setIsSelected,
    selectedIds,
    clickAction,
    showContent,
    avatar = false,
    columnIdPrefix
}) => {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: item === undefined ? -1 : item.id,
    });

    const style = transform ? {
        backgroundColor: selectedIds.indexOf(item === undefined ? -1 : item.id) !== -1 ? 'var(--peoplmap-primary)' : '',
    } : {
        backgroundColor: selectedIds.indexOf(item === undefined ? -1 : item.id) !== -1 ? 'var(--peoplmap-primary)' : '',
    };

    const [localAvatar, setLocalAvatar] = useState(avatar ? item?.avatar || item?.urlphoto : "");
    const [isDone, setIsDone] = useState(false);

    const testAvatar = async () => {
        try {
            const req = await fetch(localAvatar);
            if (req.status !== 200) setLocalAvatar("./Avatar.png");
        } catch {
            setLocalAvatar("./Avatar.png");
        } finally {
            setIsDone(true);
        }
    };
    if (!isDone && localAvatar) {
        testAvatar();
    }

    return (
        <>
            {clickAction &&
                <Button
                    className={`${columnIdPrefix}-dialog-mode-content gestion-admin-dialog-mode-content`}
                    style={style}
                    onClick={clickAction}
                >
                    {item &&
                        <>
                            {showContent(localAvatar, item)}
                        </>
                    }
                </Button>
            }
            {!clickAction &&
                <Button
                    ref={setNodeRef}
                    className={`${columnIdPrefix}-dialog-mode-content gestion-admin-dialog-mode-content`}
                    style={style}
                    onClick={() => setIsSelected(item === undefined ? -1 : item.id)}
                    {...listeners}
                    {...attributes}
                >
                    {item &&
                        <>
                            {showContent(localAvatar, item)}
                        </>
                    }
                </Button>
            }
        </>
    );
};

export default KanbanCard;
